import type { ReactNode } from 'react';

export const symbol_flight_takeoff: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M822-501 230-342q-20 5-38-2.5T163-369L66-530q-8-14-2-29.5T86-580l19-5q8-2 16.5-.5T136-579l103 87 165-45-177-236q-13-17-6-38.5t28-26.5l18-5q10-2 19.5 0t17.5 9l294 246 184-50q29-7 53.5 8t32.5 44q8 28-5.5 52.5T822-501ZM150-120q-13 0-21.5-8.5T120-150q0-13 8.5-21.5T150-180h660q13 0 21.5 8.5T840-150q0 13-8.5 21.5T810-120H150Z"
		/>
	</svg>
);
